import { render, staticRenderFns } from "./chooseKeywordIntent.vue?vue&type=template&id=68b8f452&scoped=true"
import script from "./chooseKeywordIntent.vue?vue&type=script&lang=js"
export * from "./chooseKeywordIntent.vue?vue&type=script&lang=js"
import style0 from "./chooseKeywordIntent.vue?vue&type=style&index=0&id=68b8f452&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8f452",
  null
  
)

export default component.exports